export const org = 2343243456678890;
export const useVersioning = false;
export { default as defaultThumbnailIcon } from "assets/images/default.png";

export const initialProjects = [
    '7C3434EC45B34918B6B6B584A4F99101', //Lisheen
    'DC5E551E299A4DFC933D3C05E405E52F', //Citadel Point Cloud
    'CFBD3A722B3F44FF8DF5BE0B7083E1F2', //White Sands
    '9F4E551904DB47D79B33DD4A1C3AD9B2', //Virtual Terrain Models
    //'2CEFCA086ABC4FB2A37AB5F4385F10AC', //VoxelSpace Demo
    'C61F45B0234E4062B8CC90491715A718', //VoxelSpace Demo
];

export const rawDataSources:any = {
    "RAWBM" : "Block Model",
    "RAWPC" : "Point Cloud",
    "RAWMESH" : "Mesh",
    "ORTHO": "Ortho-imagery",
};

export const validUploadFilesExtensions:any = 
    {
        "Point Cloud": ['las', 'laz', 'txt', 'xyz', 'zip'],
        "Mesh": ['obj', 'fbx', 'zip'],
        "Block Model": ['txt', 'csv', 'xls', 'xlsx', 'zip'],
        "Ortho-Imagery": ['jgw', 'pgw', 'bpw', 'taw', 'tfw', 'png', 'jpg', 'bmp', 'tga','tif', 'zip'],
        "Heightmap": ['jgw', 'pgw', 'png', 'jpg', 'zip']
    }
;

export const OutputResolutions = [
    { value:"0.3 meter", text: "0.3 meter" },
    { value:"0.6 meter", text: "0.6 meter" },
    { value:"1.2 meter", text: "1.2 meter" },
    { value:"2.4 meter", text: "2.4 meter" },
    { value:"4.8 meter", text: "4.8 meter" },
];

export const BlockModelTypes = [
    
    { value: "SKIP", text: "Ignore" },
    { value: "SET", text: "Set" },
    { value: "VALUE", text: "Value" },
    { value: "GRADE", text: "Grade" },
    { value: "XC", text: "Centroid X" },
    { value: "YC", text: "Centroid Y" },
    { value: "ZC", text: "Centroid Z" },
    { value: "XL", text: "Origin X" },
    { value: "YL", text: "Origin Y" },
    { value: "ZL", text: "Origin Z" },
    { value: "XS", text: "Dimension X" },
    { value: "YS", text: "Dimension Y" },
    { value: "ZS", text: "Dimension Z" },
];

export const BlockModelModes = [
    
    { value: "AVERAGE", text: "Average" },
    { value: "MIN", text: "Min" },
    { value: "MAX", text: "Max" },
    { value: "ADD", text: "Add" },
    { value: "MULTIPLY", text: "Multiply" },
];


export const voxbmrotation = [
    { value: "ZXZ", text: "ZXZ" },
    { value: "XYX", text: "XYX" },
    { value: "YZY", text: "YZY" },
    { value: "ZYZ", text: "ZYZ" },
    { value: "XZX", text: "XZX" },
    { value: "YXY", text: "YXY" }
];

export const coordonateOrders = [
    { value: "XYZ", text: "XYZ" },
    { value: "XZY", text: "XZY" }
];


export const HDatums = [
    { value: "wgs84", text: "World Geodetic System 1984 (WGS 84)" },
    { value: "wgs72", text: "World Geodetic System 1972 (WGS 72)" },
    { value: "grs80", text: "Geodetic Reference System 1980 (GRS 80)" },
    { value: "nad27", text: "North American Datum 1927 (NAD27)" },
    { value: "nad83", text: "North American Datum (NAD83)" },
    { value: "nad83_011", text: "North American Datum (NAD83 2011)" },
    { value: "nad83_arn", text: "North American Datum (NAD83 HARN)" },
    { value: "nad83_srs", text: "North American Datum (NAD83 CSRS)" },
    { value: "gda94", text: "Geocentric Datum of Australia 1994 (GDA94)" },
    { value: "etrs89", text: "European Terrestrial Reference System 1989 (ETRS89)" },
    { value: "agd66", text: "Australian Geodetic Datum 1966 (AGD66)" },
    { value: "clarke0", text: "Modified Clarke 1880" },
];

export const VDatums = [
    { value: "wgs84", text: "World Geodetic System 1984 (WGS 84)" },
    { value: "none", text: "None" },
    { value: "ngvd29", text: "National Geodetic Vertical Datum 1929 (NGVD 29)" },
    { value: "navd29", text: "North American Vertical Datum 29 (NAVD 29)" },
    { value: "cgvd2013", text: "Canadian Geodetic Vertical Datum 2013 (CGVD 2013)" },
    { value: "cgvd28", text: "Canadian Geodetic Vertical Datum 1928 (CGVD 28)" },
    { value: "dvr90", text: "Denmark Vertical Reference (DVR 90)" },
    { value: "nn2000", text: "Norway Normal Null 2000 (NN2000)" },
    { value: "nn54", text: "Norway Normal Null 1954 (NN54)" },
    { value: "dhhn92", text: "Deutsches Haupthoehennetz 1992 (DHHN92)" },
    { value: "navd88", text: "North American Vertical Datum  1988 (NAVD 88)" },
    { value: "navd88_geoid12b", text: "North American Vertical Datum 1988 (NAVD 88 GEOID12B)" },
    { value: "navd88_geoid12a", text: "North American Vertical Datum 1988 (NAVD 88 GEOID12A)" },
    { value: "navd88_geoid12", text: "North American Vertical Datum 1988 (NAVD 88 GEOID12)" },
    { value: "navd88_geoid09", text: "North American Vertical Datum 1988 (NAVD 88 GEOID09)" },
    { value: "navd88_geoid06", text: "North American Vertical Datum 1988 (NAVD 88 GEOID06)" },
    { value: "navd88_geoid03", text: "North American Vertical Datum 1988 (NAVD 88 GEOID03)" },
    { value: "navd88_geoid99", text: "North American Vertical Datum 1988 (NAVD 88 GEOID99)" },
    { value: "navd88_geoid96", text: "North American Vertical Datum 1988 (NAVD 88 GEOID96)" },
];

export const rawEntities = [
    "ORTHO",
    "RAW",
    "RAWPC",
    "RAWHM",
    "RAWBM",
    "RAWMESH",
    "RAWDH",
    "RAWGEOCHEM",
    "REPORT",
    "EXPORT",
    "PROGRAM",
    "PROCESS",
];

export const viewableEntitiesType = ["container"];

export const Units = [
    { value: "meter", text: "Meters" },
    { value: "feet", text: "Feet" },
    { value: "survey_feet", text: "Survey Feet" },
];

export const utmZone = [
    { value: "1", text: "1" },
    { value: "2", text: "2" },
    { value: "3", text: "3" },
    { value: "4", text: "4" },
    { value: "5", text: "5" },
    { value: "6", text: "6" },
    { value: "7", text: "7" },
    { value: "8", text: "8" },
    { value: "9", text: "9" },
    { value: "10", text: "10" },
    { value: "11", text: "11" },
    { value: "12", text: "12" },
    { value: "13", text: "13" },
    { value: "14", text: "14" },
    { value: "15", text: "15" },
    { value: "16", text: "16" },
    { value: "17", text: "17" },
    { value: "18", text: "18" },
    { value: "19", text: "19" },
    { value: "20", text: "20" },
    { value: "21", text: "21" },
    { value: "22", text: "22" },
    { value: "23", text: "23" },
    { value: "24", text: "24" },
    { value: "25", text: "25" },
    { value: "26", text: "26" },
    { value: "27", text: "27" },
    { value: "28", text: "28" },
    { value: "29", text: "29" },
    { value: "30", text: "30" },
    { value: "31", text: "31" },
    { value: "32", text: "32" },
    { value: "33", text: "33" },
    { value: "34", text: "34" },
    { value: "35", text: "35" },
    { value: "36", text: "36" },
    { value: "37", text: "37" },
    { value: "38", text: "38" },
    { value: "39", text: "39" },
    { value: "40", text: "40" },
    { value: "41", text: "41" },
    { value: "42", text: "42" },
    { value: "43", text: "43" },
    { value: "44", text: "44" },
    { value: "45", text: "45" },
    { value: "46", text: "46" },
    { value: "47", text: "47" },
    { value: "48", text: "48" },
    { value: "49", text: "49" },
    { value: "50", text: "50" },
    { value: "51", text: "51" },
    { value: "52", text: "52" },
    { value: "53", text: "53" },
    { value: "54", text: "54" },
    { value: "55", text: "55" },
    { value: "56", text: "56" },
    { value: "57", text: "57" },
    { value: "58", text: "58" },
    { value: "59", text: "59" },
    { value: "60", text: "60" },
];

export const utmNorthing = [
    { value: "C", text: "C" },
    { value: "D", text: "D" },
    { value: "E", text: "E" },
    { value: "F", text: "F" },
    { value: "G", text: "G" },
    { value: "H", text: "H" },
    { value: "J", text: "J" },
    { value: "K", text: "K" },
    { value: "L", text: "L" },
    { value: "M", text: "M" },
    { value: "N", text: "N" },
    { value: "P", text: "P" },
    { value: "Q", text: "Q" },
    { value: "R", text: "R" },
    { value: "S", text: "S" },
    { value: "T", text: "T" },
    { value: "U", text: "U" },
    { value: "V", text: "V" },
    { value: "W", text: "W" },
    { value: "X", text: "X" },
];

export const Projections = [
    { value: "merc", text: "Mercator", attributes: [] },
    { value: "latlong", text: "Latitude Longitude", attributes: [] },
    { value: "longlat", text: "Longitude Latitude", attributes: [] },
    {
        value: "utm",
        text: "Universal Transverse Mercator (UTM)",
        attributes: [
            { name: "utmZone", text: "UTM Zone", values: utmZone },
            { name: "utmNorthing", text: "UTM Northing", values: utmNorthing },
        ],
    },
    {
        value: "tm",
        text: "Transverse Mercator",
        attributes: [
            { name: "falseEasting", text: "False Easting", value: "0" },
            { name: "falseNorthing", text: "False Northing", value: "0" },
            { name: "latitudeOrigin", text: "Latitude Origin", value: "0" },
            { name: "longitudeMeridian", text: "Longitude Meridian", value: "0" },
            { name: "scaleFactor", text: "Scale Factor", value: "0" },
        ],
    },
    {
        value: "lcc",
        text: "Lambert conformal conic",
        attributes: [
            { name: "falseEasting", text: "False Easting", value: "0" },
            { name: "falseNorthing", text: "False Northing", value: "0" },
            { name: "latitudeOrigin", text: "Latitude Origin", value: "0" },
            { name: "longitudeMeridian", text: "Longitude Meridian", value: "0" },
            { name: "firstStdParallel", text: "First Std Parallel", value: "0" },
            { name: "secondStdParallel", text: "Second Std Parallel", value: "0" },
        ],
    },
    {
        value: "aeac",
        text: "AEAC",
        attributes: [
            { name: "falseEasting", text: "False Easting", value: "0" },
            { name: "falseNorthing", text: "False Northing", value: "0" },
            { name: "latitudeOrigin", text: "Latitude Origin", value: "0" },
            { name: "longitudeMeridian", text: "Longitude Meridian", value: "0" },
            { name: "firstStdParallel", text: "First Std Parallel", value: "0" },
            { name: "secondStdParallel", text: "Second Std Parallel", value: "0" },
        ],
    },
    { value: "amg", text: "AMG", attributes: [{ name: "amgZone", text: "AMG Zone", value: "48" }] },
    { value: "mga", text: "MGA", attributes: [{ name: "mgaZone", text: "MGA Zone", value: "48" }] },
    { value: "lo", text: "Lo", attributes: [{ name: "loZone", text: "Lo Zone", value: "15" }] },
];

export const FormsHelpLinks: any = {
   "project-details": "https://help.voxelspace.com/books/using-the-webui/page/project-setup#bkmrk-i",
   "project-coordinate-system": "https://help.voxelspace.com/books/using-the-webui/page/project-coordinate-system",
   "project-geographic-projection": "https://help.voxelspace.com/books/using-the-webui/page/project-coordinate-system#bkmrk-the-next-page-is-abo",
   "project-dimensions": "https://help.voxelspace.com/books/using-the-webui/page/project-coordinate-system#bkmrk-click-on-next-to-add",
   "project-objects": "https://help.voxelspace.com/books/using-the-webui/page/introduction-xq3",
   "project-objects-point-cloud": "https://help.voxelspace.com/books/using-the-webui/page/point-cloud",
   "project-objects-ortho-imagery": "https://help.voxelspace.com/books/using-the-webui/page/ortho-imagery",
   "project-objects-block-model": "https://help.voxelspace.com/books/using-the-webui/page/block-model",
   "project-objects-mesh": "https://help.voxelspace.com/books/using-the-webui/page/mesh",
   "project-objects-indexed-mesh": "https://help.voxelspace.com/books/using-the-webui/page/indexed-mesh",
   "project-objects-indexed-point-cloud": "https://help.voxelspace.com/books/using-the-webui/page/indexed-point-cloud",
   "project-objects-voxel-point-cloud": "https://help.voxelspace.com/books/using-the-webui/page/voxel-point-cloud",
   "project-objects-voxel-terrain": "https://help.voxelspace.com/books/using-the-webui/page/voxel-terrain",
   "project-objects-voxel-block-model": "https://help.voxelspace.com/books/using-the-webui/page/voxel-block-model",
   "project-objects-program": "https://help.voxelspace.com/books/using-the-webui/page/program",
   "project-objects-view": "https://help.voxelspace.com/books/using-the-webui/page/view",
   "project-objects-report": "https://help.voxelspace.com/books/using-the-webui/page/report",
   "project-objects-data-export": "https://help.voxelspace.com/books/using-the-webui/page/data-export",
   "create-view": "https://help.voxelspace.com/books/using-the-webui/page/creating-a-view",

}